import { render } from "./single-farm.vue?vue&type=template&id=79c98f4a&scoped=true&ts=true"
import script from "./single-farm.vue?vue&type=script&lang=ts"
export * from "./single-farm.vue?vue&type=script&lang=ts"

import "./single-farm.vue?vue&type=style&index=0&id=79c98f4a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c98f4a"]])

export default __exports__